import React, { useRef, useState } from 'react';

const useCopyValue = () => {
  const [copySuccess, setCopySuccess] = useState(false);
  const nodeRef = useRef<HTMLTextAreaElement | null>(null);

  const copyOnClick = async () => {
    if (!nodeRef.current) {
      return;
    }

    try {
      await navigator.clipboard.writeText(nodeRef.current.value);
      setCopySuccess(true);
      setTimeout(() => {
        setCopySuccess(false);
      }, 500);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return { nodeRef, copyOnClick, copySuccess };
};

export default useCopyValue;
